import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Api } from 'api';
import {
  Col,
  BaseModalProps,
  Modal,
  PrimaryButton,
  SecondaryButton,
  Row,
  success,
} from '@btc-snxt/ui';

interface Props extends BaseModalProps {
  userId: string;
  setIsParentModalOpen?: React.Dispatch<SetStateAction<boolean>>;
  handleDelete?: () => void;
}

const ConfirmDeleteModal: React.FC<Props> = (props): JSX.Element => {
  const { t } = useTranslation();

  const handleDelete = async () => {
    try {
      await Api.user.user.delete(props.userId);
    } finally {
      success(t('user.delete_success'));
      props.setIsOpen(false);
      props.setIsParentModalOpen && props.setIsParentModalOpen(false);
      props.handleDelete && props.handleDelete();
    }
  };

  return (
    <Modal
      {...props}
      title={t('common.confirmation')}
      size={'sm'}
      components={{
        Footer: () => {
          return (
            <div className={'d-flex justify-content-between'}>
              <Row>
                <Col>
                  <SecondaryButton onClick={handleDelete}>{t('common.yes')}</SecondaryButton>
                </Col>
                <Col>
                  <PrimaryButton
                    onClick={() => {
                      props.setIsOpen(false);
                    }}
                  >
                    {t('common.no')}
                  </PrimaryButton>
                </Col>
              </Row>
            </div>
          );
        },
      }}
    >
      <Row>
        <Col>{t('user.delete_confirm')}</Col>
      </Row>
    </Modal>
  );
};

export default ConfirmDeleteModal;
